
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import api from '../../services/api';
import useAuth from '../../hooks/useAuth';
import Multiselect from 'multiselect-react-dropdown';
// import APP_CONFIG from '../../config/appConfig';
import './Companies.css';
import Autocomplete from '../HtmlElements/Autocomplete';
import { useConfig } from '../../context/AppConfigContext';
import ScreenLoader from '../HtmlElements/ScreenLoader';
import Alert from '../HtmlElements/Alert';
import { BASE_URL } from '../../config/apiConfig';
import { API_BASE_URL } from "../../config/apiConfig";
import ConfirmDialog from '../HtmlElements/ConfirmDialog';

const AddCompany = () => {
  useAuth(); // Ensure the user is authenticated

  const navigate = useNavigate();
  const { companyId } = useParams(); // Get companyId from URL parameters
  const [loader, setLoader] = useState(false);

  const [formData, setFormData] = useState({
    companyName: '',
    accountType: 1,
    accountStatus: 1,
    subscriptionStartDate: new Date(),
    subscriptionEndDate: new Date(),
    contractStartDate: new Date(),
    contractEndDate: new Date(),
    companyDomain: '',
    numberOfUsers: '',
    ticketSize: '',
    leadId: '',
    ksCompanyName: '',
    ksCompanyCode: '',
    hqCity: '',
    hqCountry: '',
    hqRegion: '',
    ipauthentication: '', 
    accountmanager: '',
    subscriptionaccount: '',
    allowedDomains: '',
    companyWebsite: '',
    subscriptionType: '',
    subscribedNoOfAccounts: '',
    subscribedAccounts: '',
    newaccountname: '',
    analystHours: '',
    po_files: [],
    msg_files: []
  });
  

  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState('');
  const [files, setFiles] = useState([]);
  const [POfiles, setPOFiles] = useState([]);
  const [msgFile, setMsgFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState([]);
  const [emailuploadedFiles, setEmailUploadedFiles] = useState([]);
  const [POuploadedFiles, setPOUploadedFiles] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [success_message, setSuccessMessage] = useState('');
  const [fileToDelete, setFileToDelete] = useState(null);

  const {appConfig} = useConfig();
  
  useEffect(() => {
    if (companyId) {

      setLoader(true);
      // Fetch existing company data if editing
      const filterData = {'id': companyId }
      api.get('/companies/get_companies', { "params": filterData })
        .then(response => {
          const company = response?.data?.result?.list[0] ;

          setFormData({
            companyName: company.company_name ,
            accountType: company.account_type || 1,
            accountStatus: company.is_active || 0,
            ipauthentication: company.ipauthentication || 'No',
            subscriptionStartDate: new Date(company.subscription_start_date) ,
            subscriptionEndDate: new Date(company.subscription_end_date) ,
            contractStartDate: new Date(company.contract_start_date) ,
            contractEndDate: new Date(company.contract_end_date) ,
            companyDomain: company.company_domain ,
            numberOfUsers: parseInt(company.number_of_privileged_users) ,
            ticketSize: parseInt(company.ticket_size) ,
            leadId: company.lead_id ,
            ksCompanyName: company?.ks_company_name ,
            ksCompanyCode: company?.ks_company_code ,
            hqCity: company?.hq_city ,
            hqCountry: company.hq_country ,
            hqRegion: company.hq_region ,
            accountmanager: company.account_managers ,
            subscriptionaccount: company.subscriptionaccount ,
            allowedDomains: company.allowedDomains ,
            companyWebsite: company.companyWebsite ,
            subscriptionType: company.subscriptionType ,
            subscribedNoOfAccounts: company.subscribedNoOfAccounts ,
            subscribedAccounts: company.subscribedAccounts ,
            newaccountname: company.newaccountname ,           
            analystHours: company.analystHours ,
            po_files: company.po_files ,
            msg_files: company.msg_files,
          });
        })
        .catch(error => {
          setApiError('Error fetching company data');
          console.error('Error fetching company data:', error);
        });
      setLoader(false);
    }
  }, [companyId]);



  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value !== undefined ? value : '',
    }));

    // Clear the error for the current field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));


    // Clear API error
    setApiError('');
  };

  const handleAutoCompleteChange = (e) => {
    const { name, value, code } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if(name === "ksCompanyName"){
      setFormData((prevState) => ({
        ...prevState,
        'ksCompanyCode': code,
      }));
    }
  }
  
  const handleDateChange = (name, date) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: date || new Date(),
    }));

    // Clear date-related errors
    if (['subscriptionStartDate', 'subscriptionEndDate'].includes(name)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        subscriptionEndDate: '',
      }));
    }

    if (['contractStartDate', 'contractEndDate'].includes(name)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        contractEndDate: '',
      }));
    }

    // Clear API error
    setApiError('');
  };

  const handleFilesChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    setFiles(selectedFiles);
    uploadFiles(selectedFiles, 'po_file'); // Automatically upload selected files
};

const handleMsgFileChange = (event) => {
    const selectedMsgFile = event.target.files[0];
    setMsgFile(selectedMsgFile);
    uploadFiles([selectedMsgFile], 'email_file'); // Automatically upload the .msg file
};

const uploadFiles = async (filesToUpload, file_field_name) => {
    if (filesToUpload.length === 0) {
        return; // Exit if no files are selected
    }

    const uploadFormData = new FormData();
    uploadFormData.append('file_field_name', file_field_name);
    filesToUpload.forEach(file => uploadFormData.append('files', file));

    setUploadStatus(filesToUpload.map(file => ({ name: file.name, status: 'Uploading...' })));

    try {
        const response = await api.post('/storage/upload', uploadFormData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        const updatedStatus = [];
        const emailuploadedFilesData = [];
        const POuploadedFilesData = [];
        if(response.data.result.uploaded_files[0].file_field_name == 'email_file') {
          const emailuploadedFilesData = response.data.result.uploaded_files;        
          // Format updatedStatus like the JSON response
          const updatedStatus = emailuploadedFilesData.map(file => ({
              file_field_name: file.file_field_name,
              file_id: file.file_id,
              filename: file.filename,
          }));  
          //setUploadStatus(updatedStatus); // Update the uploadedFiles state
          var msgtmp = [...formData?.msg_files || [], ...emailuploadedFilesData];
         
          setFormData((prevState) => ({
            ...prevState,
            ['msg_files']: msgtmp,
          }));

          //setEmailUploadedFiles(emailuploadedFilesData); 
        } else if(response.data.result.uploaded_files[0].file_field_name == 'po_file') {
          const POuploadedFilesData = response.data.result.uploaded_files;        
          // Format updatedStatus like the JSON response
          const updatedStatus = POuploadedFilesData.map(file => ({
              file_field_name: file.file_field_name,
              file_id: file.file_id,
              filename: file.filename,
          }));  
          setUploadStatus(updatedStatus); // Update the uploadedFiles state
          
          var tmp = [...formData?.po_files || [], ...POuploadedFilesData];

          setFormData((prevState) => ({
            ...prevState,
            ['po_files']: tmp,
          }));
          //setPOUploadedFiles(POuploadedFilesData);
          //setPOUploadedFiles(tmp);

        } else {}
        //const updatedStatus = response.data.map(file => ({ name: file.name, status: 'Uploaded' }));
        setUploadStatus(updatedStatus);
        
    } catch (error) {
       // const updatedStatus = filesToUpload.map(file => ({ name: file.name, status: 'Upload failed' }));
       const updatedStatus = "Failed"; 
       setUploadStatus(updatedStatus);
        console.error('Upload error:', error);
        
    }
};
      const [isValid, setIsValid] = useState(true);
      const validateUrl = (input) => {
        // Regular expression to validate URLs with or without protocol (http, https, ftp)
        const urlPattern = /^(ftp|http|https):\/\/[^ "]+$|^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}$/;
        
        return urlPattern.test(input);
      };


  const validateForm = () => {
    let newErrors = {};
    setIsValid(validateUrl(formData.companyWebsite));

    if (!formData.companyName){
      newErrors.companyName = 'Company Name is required';
    }else if(/[~`!@#$%\^*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(formData.companyName)){
      newErrors.companyName = 'Special characters are not allowed in Company Name';
    }

    if (!formData.hqCity){
      newErrors.hqCity = 'HQ City is required';
    }else if(/[~`!@#$%\^*+=\-\[\]\\';,/{}|\\":<>0-9\?]/g.test(formData.hqCity)){
      newErrors.hqCity = 'Numbers and Special characters are not allowed in City Name';
    }

    /*if (files.length === 0) {      
      newErrors.pofiles = 'Please upload at least one file.';      
  }
  if (!msgFile) {      
      newErrors.msgfile = 'Please upload a .msg file.';     
  }*/

    if (!formData.hqCountry) newErrors.hqCountry = 'HQ Country is required';
    if (!formData.hqRegion) newErrors.hqRegion = 'HQ Region is required';
    if (!formData.companyDomain) newErrors.companyDomain = 'Industry is required';
    if (!formData.numberOfUsers || isNaN(formData.numberOfUsers)) newErrors.numberOfUsers = 'Number of Users is required and must be numeric';
    if (!formData.ticketSize || isNaN(formData.ticketSize)) newErrors.ticketSize = 'Ticket Size is required and must be numeric';
    if (formData.subscriptionEndDate <= formData.subscriptionStartDate) newErrors.subscriptionEndDate = 'Subscription End Date must be greater than Subscription Start Date';
    if (formData.contractEndDate <= formData.contractStartDate) newErrors.contractEndDate = 'Contract End Date must be greater than Contract Start Date';
    if (!formData.leadId) newErrors.leadId = 'lead Id is required';
    if (!formData.companyWebsite || !isValid) newErrors.companyWebsite = 'Company Website Valid URL is required';
    //if (!formData.subscriptionAccounts) newErrors.subscriptionAccounts = 'Subscription Account is required';
    //if (!formData.subscriptionType) newErrors.subscriptionType = 'Subscription Type is required';
    if (!formData.subscribedNoOfAccounts || isNaN(formData.subscribedNoOfAccounts)) newErrors.subscribedNoOfAccounts = 'Subscribed Number of Accounts is required and must be numeric';
    if (!formData.allowedDomains) newErrors.allowedDomains = 'Allowed Domain is required';
    if (!formData.analystHours || isNaN(formData.analystHours)) newErrors.analystHours = 'Analyst Hours is required and must be numeric';
    // if (!formData.ksCompanyName) newErrors.ksCompanyName = 'Ks Company is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) {
      return;
    }     

    const formattedData = {
      company_name: formData.companyName,
      account_type: formData.accountType,
      account_id: companyId ? formData.accountId : 'IBM-25JUNE24',
      is_active: parseInt(formData.accountStatus),
      is_deleted: 0,
      subscription_start_date: moment(formData.subscriptionStartDate).format('YYYY-MM-DD'),
      subscription_end_date: moment(formData.subscriptionEndDate).format('YYYY-MM-DD'),
      contract_start_date: moment(formData.contractStartDate).format('YYYY-MM-DD'),
      contract_end_date: moment(formData.contractEndDate).format('YYYY-MM-DD'),
      account_managers: formData.accountmanager,
      number_of_privileged_users: formData.numberOfUsers,
      ticket_size: formData.ticketSize,
      lead_id: formData.leadId,
      ks_company_name: formData.ksCompanyName,
      ks_company_code: formData.ksCompanyCode,
      hq_city: formData.hqCity,
      hq_country: formData.hqCountry,
      hq_region: formData.hqRegion,
      company_domain: formData.companyDomain,
      ipauthentication: formData.ipauthentication,
      //accountmanager: formData.accountmanager,
      subscriptionaccount: formData.subscriptionaccount,
      allowedDomains: formData.allowedDomains,
      companyWebsite: formData.companyWebsite,
      subscriptionType: formData.subscriptionType,
      subscribedNoOfAccounts: formData.subscribedNoOfAccounts,
      subscribedAccounts: formData.subscribedAccounts,
      newaccountname: formData.newaccountname,
      analystHours: formData.analystHours,
      deletedFiles: deletedFiles,     
     }; 
     if (POuploadedFiles && Array.isArray(POuploadedFiles) && POuploadedFiles.length > 0) {
      formattedData.po_files = POuploadedFiles;
     } else { formattedData.po_files = formData.po_files }
     if (emailuploadedFiles && Array.isArray(emailuploadedFiles) && emailuploadedFiles.length > 0) {
      formattedData.msg_files = emailuploadedFiles;
     } else { formattedData.msg_files = formData.msg_files; }


    console.log(formattedData);
    setLoader(true);

    try {

      if(companyId){
        formattedData.id = companyId
      }
      //const response = await api.post('/companies/add_company', formattedData);
      const response = await api.post('/companies/add_company', formattedData);
      
      if (response.data.status === 201 || response.data.status === 200) {
        // navigate('/companies', { state: { success_message: response.data.result.message } });
        sessionStorage.setItem('successMessage', response.data.result.message);
        navigate('/companies');
        
      } else {
        setApiError(response.data.result.message || 'An error occurred while saving the company.');
      }
    } catch (error) {
      const errorMsg = error.response?.data?.message || 'An error occurred while saving the company.';
      setApiError(errorMsg);
      console.error('Error saving company:', error);
    }

    setLoader(false);

  };
  const [users, setUsers] = useState([]);

  useEffect(() => {
    // Fetch company list from the API
    const fetchUsers = async () => {
      setLoader(true);
      try {
        const filterData = {'is_active': 1, is_deleted: 0, role:30, limit: 1000}
        const response = await api.get('/users/get_users_list', { "params": filterData })
        let users = [...response.data.result.list] ;
        
        users = users.map(user => {
          return {
              ...user,
              display_name: user.firstname +" "+user.lastname
          };
        });

        setUsers(users); // Assuming the response contains an array of users

      } catch (error) {
        console.error('Error fetching users:', error);
      }
      setLoader(false);
    };

    fetchUsers();
  }, []);
  // console.log(users);
  const handleChangeMultiSelect = (accountsmgrArr) => {
    const newAccountMgr = accountsmgrArr.map((accountsmgrObj) => {
      return accountsmgrObj.id
    });
    setFormData({ ...formData, accountmanager: newAccountMgr});
  }

  const handleRemoveMultiSelect = (selectedList) => {
    const selectedIds = selectedList.map(item => item.id);
    setFormData({
      ...formData,
      accountmanager: selectedIds
    });
  };
  const [deletedFiles, setDeletedFiles] = useState([]);
  const handleDelete = async () => {
    setLoader(true);
    try {
     /** await api.delete(`/companies/delete_file/${fileToDelete}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`
        }
      });*/
      //alert(fileToDelete);
      //setDeletedFiles((prev) => [...prev, fileToDelete]);
      setDeletedFiles((prev) => {
        const updatedDeletedFiles = [...prev, fileToDelete];
        console.log("Updated deleted files:", updatedDeletedFiles); // Log updated files
        return updatedDeletedFiles;
      });

      //console.log("ddddddddddd:", deletedFiles);
      setSuccessMessage("File Deleted Successfully...");
      hideDeleteConfirm();
      setFormData((prevState) => {
        const updatedPoFiles = prevState.po_files.filter(file => file.file_id !== fileToDelete);
        return {
          ...prevState,
          po_files: updatedPoFiles,
        };
      });
      setFormData((prevState) => {
        const updatedEmailFiles = prevState.msg_files.filter(file => file.file_id !== fileToDelete);
        return {
          ...prevState,
          msg_files: updatedEmailFiles,
        };
      });



      //setCompanies((prevCompanies) => prevCompanies.filter(file => file.file_id !== fileToDelete));
    } catch (error) {
      console.error('Error deleting File:', error);
    }
    setLoader(false);
  };

  const showDeleteConfirm = (companyId) => {
    setFileToDelete(companyId);
    setShowConfirm(true);
  };

  const hideDeleteConfirm = () => {
    setShowConfirm(false);
    setFileToDelete(null);
  };

  if(!appConfig){
    return <div> </div>;
  }

  const accountTypes = appConfig.account_types;
  const accountStatusOpt = appConfig.account_status_opt;
  const regionOptions = appConfig.region_options;
  const countryOptions = appConfig.country_options;
  const companyDomains = appConfig.company_domains;
  const subscriptionAccounts = appConfig.subscription_accounts;
  const subscriptionTypes = appConfig.subscription_types;
  const ipauthentications = appConfig.ip_authentication;
   
  const getselectedAMObjects = (AMIds) => {
    return users.filter(amuser => AMIds.includes(amuser.id));
  };

  const selectedAMObjects = getselectedAMObjects(formData.accountmanager);
  console.log(emailuploadedFiles);
  console.log(POuploadedFiles); 
  //setPOUploadedFiles(formData.po_files); 



  return (
    <div className="add_company_wrapper">
      { loader === true && (<ScreenLoader />) }
      <div className="mt-3">
        <div className='head_back'>
        <h4 className="add_user_headings mb-0">{companyId ? 'Edit Client' : 'Add Client'}</h4>
        </div>
        {apiError && <Alert type="danger" message={apiError} />}
        <div className="row">
          <div className="col-md-12">
            <Form onSubmit={handleSubmit} autoComplete='off'>
              <div className="row custom_pad">
                <div className="col-md-3 ">
                  <label htmlFor="labelCompanyName" className="form-label custom_label">Client Name <span className='red'>*</span></label>
                  <input
                    type="text"
                    className="form-control custom_form_control"
                    id="labelCompanyName"
                    name="companyName"
                    onChange={handleChange}
                    value={formData.companyName}/>
                  {errors.companyName && <div className="text-danger custom_error_msg">{errors.companyName}</div>}
                </div>
                <div className="col-md-3">
                  <label htmlFor="labelAccountType" className="form-label custom_label">Account Type</label>
                  <Form.Control
                    className="custom_form_control"
                    as="select"
                    name="accountType"
                    value={formData.accountType}
                    onChange={handleChange}>
                    {Object.keys(accountTypes).map((key) => (
                      <option key={key} value={key}>{accountTypes[key]}</option>
                    ))}
                  </Form.Control>
                </div>                  
                <div className="col-md-3">
                  <label htmlFor="labelLeadId" className="form-label custom_label">Lead Id <span className='red'>*</span></label>
                  <input
                    type="number"
                    className="form-control custom_form_control"
                    id="labelLeadId"
                    name="leadId"
                    onChange={handleChange}
                    value={formData.leadId}/>
                  {errors.leadId && <div className="text-danger custom_error_msg">{errors.leadId}</div>}
                </div>        
                <div className="col-md-3">
                  <label htmlFor="labelAccountStatus" className="form-label custom_label">Account Status</label>
                  <Form.Control
                    className="custom_form_control"
                    as="select"
                    name="accountStatus"
                    value={formData.accountStatus}
                    onChange={handleChange}>
                    {Object.keys(accountStatusOpt).map((key) => (
                      <option key={key} value={key}>{accountStatusOpt[key]}</option>
                    ))}
                  </Form.Control>
                </div>
               
              </div>
              <div className="row custom_pad">
                <div className="col-md-3">
                  <label htmlFor="labelSubscriptionStartDate" className="form-label custom_label">Subscription Start Date</label>
                  <DatePicker
                    selected={formData.subscriptionStartDate}
                    onChange={(date) => handleDateChange('subscriptionStartDate', date)}
                    dateFormat="yyyy-MM-dd"
                    className="form-control custom_form_control"
                    id="labelSubscriptionStartDate"/>
                </div>
                <div className="col-md-3">
                  <label htmlFor="labelSubscriptionEndDate" className="form-label custom_label">Subscription End Date <span className='red'>*</span></label>
                  <DatePicker
                    selected={formData.subscriptionEndDate}
                    onChange={(date) => handleDateChange('subscriptionEndDate', date)}
                    dateFormat="yyyy-MM-dd"
                    className="form-control custom_form_control"
                    id="labelSubscriptionEndDate"/>
                  {errors.subscriptionEndDate && <div className="text-danger custom_error_msg">{errors.subscriptionEndDate}</div>}
                </div>                
              
                <div className="col-md-3">
                  <label htmlFor="labelAccountStatus" className="form-label custom_label">Account Manager</label>
                  <Multiselect
                        name="accountmanager"
                        // value={formData.userRoles}
                        options={users}
                        onSelect={handleChangeMultiSelect}
                        onRemove={handleRemoveMultiSelect}
                        displayValue="display_name"
                        selectedValues={selectedAMObjects}
                        showCheckbox="true"
                        placeholder="Select Account Manager"></Multiselect>
                      {errors.accountmanager && <div className="text-danger custom_error_msg">{errors.accountmanager}</div>}
                    
                </div> 
                <div className="col-md-3">
                  <label htmlFor="labelNumberOfUsers" className="form-label custom_label">Number of Users <span className='red'>*</span></label>
                  <input
                    type="number"
                    className="form-control custom_form_control"
                    id="labelNumberOfUsers"
                    name="numberOfUsers"
                    onChange={handleChange}
                    value={formData.numberOfUsers}/>
                  {errors.numberOfUsers && <div className="text-danger custom_error_msg">{errors.numberOfUsers}</div>}
                </div>
                </div>
              <div className="custom_pad row mb-3">
                           
               
                <div className="col-md-6">                  
                  <input 
                        type="file" 
                        name="pofiles" // name attribute for multiple files
                        onChange={handleFilesChange}
                        id='po-input' 
                        className='input_add'
                        multiple 
                        style={{ display: 'none' }} // Hide the file input
                    />  
                  {<label htmlFor="po-input" className='input_add'>
                  <i className="fa fa-paperclip" aria-hidden="true"></i> Attach PO File
                  </label>} 
                   
                {POuploadedFiles.map((file, index) => (
                    <div key={index}>{file.filename}</div>
                ))}
                <div className='po_attachement'>PO Attachments :
                {formData.po_files && formData.po_files.length > 0 && formData.po_files.map((file, index) => (
              
                    <div className="updated_files">
                      <div className="row">
                      <div className="col-md-10" style={{wordWrap: 'break-word'}}><Link to={`${API_BASE_URL}/storage/download/${file.file_id}`} style={{color:'#212529'}}>{file.filename}</Link></div>
                      <div className="col-md-2 delete_icon_block" style={{float: 'right', textAlign: 'right'}}> <span
                  onClick={() => showDeleteConfirm(file.file_id)}
                  className="cursor_p" style={{color: '#E11340'}}>
                  <i className="fa fa-trash"></i> 
                   </span> </div>
                    </div>
                    </div>
                ))}
            </div>
                  {errors.pofiles && <div className="text-danger custom_error_msg">{errors.pofiles}</div>}
                </div>
                <div className="col-md-6">
                  <input 
                        type="file" 
                        name="msgfile" // name attribute for .msg file
                        accept=".msg" 
                        onChange={handleMsgFileChange} 
                        id='msg-input'
                        style={{ display: 'none' }} // Hide the file input
                    />
                  {<label htmlFor="msg-input" className='input_add'>
                  <i className="fa fa-paperclip" aria-hidden="true"></i> Attach Email File
                  </label> } 
                  
                {emailuploadedFiles.map((file, index) => (
                    <div key={index}>{file.filename}</div>
                ))} 
                <div className='po_attachement'>Email Attachment:
                {formData.msg_files && formData.msg_files.length > 0 && formData.msg_files.map((file, index) => (
              
              <div className="updated_files">
                <div className='row'>
                <div className="col-md-10" style={{wordWrap: 'break-word'}}><Link to={`${API_BASE_URL}/storage/download/${file.file_id}`} style={{color:'#212529'}}>{file.filename}</Link></div>
                <div className="col-md-2 delete_icon_block"> 
                <span
            onClick={() => showDeleteConfirm(file.file_id)}
            className="cursor_p" style={{color: '#E11340'}}>
            <i className="fa fa-trash"></i> 
             </span> </div>
              </div>
              </div>
          ))}
              </div>              
                            
                  {errors.msgfile && <div className="text-danger custom_error_msg">{errors.msgfile}</div>}
                </div>
              </div>

              <div className='head_back'>
        <h4 className="add_user_headings mb-0">Additional Details</h4>
        </div>   
              <div className="custom_pad row"> 
              <div className="col-md-3">
                  <label htmlFor="labelAccountStatus" className="form-label custom_label">Subscription Account</label>
                  <Form.Control
                    className="custom_form_control"
                    as="select"
                    name="subscriptionaccount"
                    value={formData.subscriptionaccount}
                    onChange={handleChange}>
                    {Object.keys(subscriptionAccounts).map((key) => (
                      <option key={key} value={key}>{subscriptionAccounts[key]}</option>
                    ))}
                  </Form.Control>
                  {errors.subscriptionaccount && <div className="text-danger custom_error_msg">{errors.subscriptionaccount}</div>}
                </div>

                <div className="col-md-3">
                  <label htmlFor="labelTicketSize" className="form-label custom_label">Ticket Size <span className='red'>*</span></label>
                  <input
                    type="number"
                    className="form-control custom_form_control"
                    id="labelTicketSize"
                    name="ticketSize"
                    onChange={handleChange}
                    value={formData.ticketSize}/>
                  {errors.ticketSize && <div className="text-danger custom_error_msg">{errors.ticketSize}</div>}
                </div>
                
                <div className="col-md-3">
                  <label htmlFor="labelHqCity" className="form-label custom_label">HQ City <span className='red'>*</span></label>
                  <input
                    type="text"
                    className="form-control custom_form_control"
                    id="labelHqCity"
                    name="hqCity"
                    onChange={handleChange}
                    value={formData.hqCity}/>
                  {errors.hqCity && <div className="text-danger custom_error_msg">{errors.hqCity}</div>}
                </div>
                <div className="col-md-3">
                  <label htmlFor="labelHqCountry" className="form-label custom_label">HQ Country <span className='red'>*</span></label>
                  <Form.Control
                    className="custom_form_control"
                    as="select"
                    name="hqCountry"
                    value={formData.hqCountry}
                    onChange={handleChange}>
                    <option key="" value="">Select HQ Country</option>
                    {Object.keys(countryOptions).map((key) => (
                      <option key={key} value={key}>{countryOptions[key]}</option>
                    ))}
                  </Form.Control>
                  {errors.hqCountry && <div className="text-danger custom_error_msg">{errors.hqCountry}</div>}
                </div>
                </div>
              <div className="custom_pad row mb-3">
                <div className="col-md-3">
                  <label htmlFor="labelHqRegion" className="form-label custom_label">HQ Region <span className='red'>*</span></label>
                  <Form.Control
                    className="custom_form_control"
                    as="select"
                    name="hqRegion"
                    value={formData.hqRegion}
                    onChange={handleChange}>
                    <option key="" value="">Select HQ Region</option>
                    {Object.keys(regionOptions).map((key) => (
                      <option key={key} value={key}>{regionOptions[key]}</option>
                    ))}
                  </Form.Control>
                  {errors.hqRegion && <div className="text-danger custom_error_msg">{errors.hqRegion}</div>}
                </div>
                <div className="col-md-3">
                  <label htmlFor="labelCompanyDomain" className="form-label custom_label">Industry <span className='red'>*</span></label>
                  <Form.Control
                    className="custom_form_control"
                    as="select"
                    name="companyDomain"
                    value={formData.companyDomain}
                    onChange={handleChange}>
                    <option key="" value="">Select Industry</option>
                    {Object.keys(companyDomains).map((key) => (
                      <option key={key} value={key}>{companyDomains[key]}</option>
                    ))}
                  </Form.Control>
                  {errors.companyDomain && <div className="text-danger custom_error_msg">{errors.companyDomain}</div>}
                </div>
                <div className="col-md-3">
                  <label htmlFor="labelCompanyWebsite" className="form-label custom_label">Company Website<span className='red'>*</span></label>
                  <input
                    type="text"
                    className="form-control custom_form_control"
                    id="labelCompanyWebsite"
                    name="companyWebsite"
                    onChange={handleChange}
                    value={formData.companyWebsite}/>
                  {errors.companyWebsite && <div className="text-danger custom_error_msg">{errors.companyWebsite}</div>}
                </div>
                <div className="col-md-3">
                  <label htmlFor="labelAllowedDomains" className="form-label custom_label">Allowed Domains <span className='red'>*</span></label>
                  <input
                    type="text"
                    className="form-control custom_form_control"
                    id="labelallowedDomain"
                    name="allowedDomains"
                    onChange={handleChange}
                    value={formData.allowedDomains}/>
                    {errors.allowedDomains && <div className="text-danger custom_error_msg">{errors.allowedDomains}</div>}
                </div>   



              </div>

              <div className='head_back'>
        <h4 className="add_user_headings mb-0">Access Details</h4>
        </div>

              <div className="custom_pad row">                
              
                <div className="col-md-3">
                  <label htmlFor="labelNumberOfUsers" className="form-label custom_label">Subscribed Number of Accounts <span className='red'>*</span></label>
                  <input
                    type="number"
                    className="form-control custom_form_control"
                    id="labelSubscribedNoOfAccounts"
                    name="subscribedNoOfAccounts"
                    onChange={handleChange}
                    value={formData.subscribedNoOfAccounts}/>
                  {errors.subscribedNoOfAccounts && <div className="text-danger custom_error_msg">{errors.subscribedNoOfAccounts}</div>}
                </div>
                <div className="col-md-3">
                  <label htmlFor="labelAnalystHours" className="form-label custom_label">Analyst Hours <span className='red'>*</span></label>
                  <input
                    type="number"
                    className="form-control custom_form_control"
                    id="labelanalystHours"
                    name="analystHours"
                    onChange={handleChange}
                    value={formData.analystHours}/>
                  {errors.analystHours && <div className="text-danger custom_error_msg">{errors.analystHours}</div>}
                </div>
                
                <div className="col-md-3">
                  <label htmlFor="labelKsCompanyName" className="form-label custom_label">Ks Company Name <span className='red'>*</span></label>
                  <Autocomplete
                      name="ksCompanyName"
                      key="suggest_ks_company_name"
                      value={formData.ksCompanyName}
                      onChange={handleAutoCompleteChange}
                      placeholder="Ks Company Name"
                      element_field_key="ksCompanyName"
                      // setCode={function(){return true}}
                      apiUrl="/company_profiles/suggest_company_name"
                      labelKey="name"
                      valueKey="code"/>
                  {errors.ksCompanyName && <div className="text-danger custom_error_msg">{errors.ksCompanyName}</div>}
                </div>
                <div className="col-md-3">
                  <label htmlFor="labelIpAuthentication" className="form-label custom_label">IP Authentication</label>
                  <Form.Control
                    className="custom_form_control"
                    as="select"
                    name="ipauthentication"
                    value={formData.ipauthentication}
                    onChange={handleChange}>
                     {Object.keys(ipauthentications).map((key) => (
                      <option key={key} value={key}>{ipauthentications[key]}</option>
                    ))}
                  </Form.Control>
                </div>
              </div>
              <div className="custom_pad row">
                
                <div className="col-md-3">
                  <label htmlFor="labelContractStartDate" className="form-label custom_label">Contract Start Date</label>
                  <DatePicker
                    selected={formData.contractStartDate}
                    onChange={(date) => handleDateChange('contractStartDate', date)}
                    dateFormat="yyyy-MM-dd"
                    className="form-control custom_form_control"
                    id="labelContractStartDate"/>
                </div>
                <div className="col-md-3">
                  <label htmlFor="labelContractEndDate" className="form-label custom_label">Contract End Date <span className='red'>*</span></label>
                  <DatePicker
                    selected={formData.contractEndDate}
                    onChange={(date) => handleDateChange('contractEndDate', date)}
                    dateFormat="yyyy-MM-dd"
                    className="form-control custom_form_control"
                    id="labelContractEndDate"/>
                  {errors.contractEndDate && <div className="text-danger custom_error_msg">{errors.contractEndDate}</div>}
                </div>
                </div>
                <div className="custom_pad row">

                

                
              </div>
              <div className="row p-3">
                <div className="col-md-12">
                  <Button variant="primary" type="submit" className="custom_login_btn pull-right">{companyId ? 'Update' : 'Submit'}</Button>
                  <Link to="/companies/" className="btn btn-light pull-right cancel_btn">Cancel</Link>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <ConfirmDialog
      show={showConfirm}
      handleClose={hideDeleteConfirm}
      handleConfirm={handleDelete}
      title="Delete File"
      message="Are you sure you want to delete this File?"/>
    </div>
    
  );
};

export default AddCompany;
